export default __webpack_public_path__ + "e42dde2635a46ed98a9d73375a2c429e.svg";